/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeaturerefine2Inputs */

const en_aifeaturerefine2 = /** @type {(inputs: Aifeaturerefine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image refinement`)
};

const de_aifeaturerefine2 = /** @type {(inputs: Aifeaturerefine2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild überarbeiten`)
};

/**
* | output |
* | --- |
* | "Image refinement" |
*
* @param {Aifeaturerefine2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeaturerefine2 = /** @type {((inputs?: Aifeaturerefine2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeaturerefine2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeaturerefine2(inputs)
	return de_aifeaturerefine2(inputs)
});
export { aifeaturerefine2 as "aiFeatureRefine" }